import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

const HomePage = () => {
  return <Outlet />;
};

export const Route = createFileRoute("/_private/")({
  beforeLoad: () => {
    throw redirect({ to: "/profiles" });
  },
  component: HomePage,
});
